export default "./9d60ee7c24073ef4df90fdc56f6e672a.svg";